"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplyButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _ButtonTs = _interopRequireDefault(require("@lt/components/components/ButtonTs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ApplyButton = function ApplyButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      buttonRef = _ref.buttonRef;
  return /*#__PURE__*/_react["default"].createElement(StyledButton, {
    disabled: disabled,
    size: "large",
    offHover: true,
    onClick: onClick,
    buttonRef: buttonRef
  }, children);
};

exports.ApplyButton = ApplyButton;
var StyledButton = (0, _styledComponents["default"])(_ButtonTs["default"]).withConfig({
  displayName: "ApplyButton__StyledButton",
  componentId: "sc-xhjnke-0"
})(["&&{display:flex;flex-direction:column;align-items:center;justify-content:center;width:inherit;margin:0 auto;background-color:var(--orange);border-radius:var(--border-radius);border:none;color:var(--white);font-size:14px;transition:0.3s;padding:8px 16px;&:hover{transform:scale(1.02);}}"]);